import { combineReducers } from "redux";
import clientReducer from './clientReducer';
import skpReducer from "./skpReducer";

export default combineReducers({
    client: clientReducer,
    SKP: skpReducer
})